import { render, staticRenderFns } from "./dashboard-managers.vue?vue&type=template&id=76b97a30&scoped=true&"
import script from "./dashboard-managers.vue?vue&type=script&lang=js&"
export * from "./dashboard-managers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b97a30",
  null
  
)

export default component.exports